export default "__VITE_ASSET__dbd89bdd__"